import React from 'react';
import { render } from 'react-dom';
import App from './App';
import * as serviceWorker from './services/serviceWorker/serviceWorker';
import Store, { persistor } from './store/configureStore';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import './index.css';
import { initSentry } from './services/sentry/init';
import userAgentCheck from './services/userAgent/checkFront';
import cycleToUpdate from './services/pwa/cycleToUpdate';
import {
  beforeInstallPrompt,
  cycleInstalledFirst
} from './services/pwa/beforeInstallPrompt';
import { ErrorBoundary } from '@sentry/react';
import { ErrorLayout } from 'components/layouts/ErrorLayout';
import { PersistGate } from 'redux-persist/integration/react';
import client from './appolloConfig';
import initDummy from './helpers/fakers/init';
import { Router } from 'react-router-dom';
import history from './routes/history';
import Feedback from './components/organisms/Feedback';
import { Toaster } from 'react-hot-toast';

initSentry();
userAgentCheck();
beforeInstallPrompt();
initDummy();

render(
  <ApolloProvider client={client}>
    <PersistGate persistor={persistor}>
      <Provider store={Store}>
        <ErrorBoundary
          beforeCapture={scope => {
            scope.setTag('UI', 'From ErrorBoundary');
          }}
          showDialog
          fallback={<ErrorLayout />}
        >
          <Router history={history}>
            <App />
            <Feedback />
            <Toaster position="bottom-center" />
          </Router>
        </ErrorBoundary>
      </Provider>
    </PersistGate>
  </ApolloProvider>,
  document.getElementById('root')
);

serviceWorker.register({
  onUpdate: cycleToUpdate,
  onSuccess: cycleInstalledFirst
});
